import { useApplicantAPI } from "@certn/api";
import { rem } from "@certn/cascadia";
import { Text, useLayout, mq } from "@certn/cascadia-react";
import { layouts } from "@certn/cascadia-tokens";
import { css } from "@emotion/css";
import { Trans } from "react-i18next";
import { useParams } from "react-router-dom";

import { CheckStatus } from "../../components/check-status/CheckStatus";

export function ReportHeader() {
  const styles = useStyles();
  const { caseId } = useParams();
  const { data } = useApplicantAPI(
    `/api/internal/applicant/case/${caseId}/report/` as "/api/internal/applicant/case/{id}/report/"
  );

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <Text as="h1" style="global/title-large">
          <Trans>Case Details</Trans>
        </Text>
        <div className={styles.subtitle}>
          <CheckStatus type="complete" hasGrayBackground>
            <Trans>Complete</Trans>
          </CheckStatus>
          <Text style="global/body-secondary">
            <Trans>Requested by</Trans>: {data?.case.customer_name ?? "-"}
          </Text>
        </div>
      </div>
    </div>
  );
}

function useStyles() {
  const { layout } = useLayout();
  const layoutValues = layouts[layout];

  return {
    container: css({
      display: "flex",
      justifyContent: "center",
      padding: `${"var(--space-4)"} 0`,
      paddingLeft: layoutValues.marginHorizontal.map(rem),
      paddingRight: layoutValues.marginHorizontal.map(rem),
    }),
    content: css(
      mq({
        width: layoutValues.maxWidth,
      })
    ),
    subtitle: css(
      {
        display: "flex",
        gap: "var(--space-4)",
        margin: `${"var(--space-2)"} 0`,
      },
      mq({
        flexDirection: ["column", "row"],
        alignItems: ["start", "center"],
      })
    ),
  };
}
